export default "__VITE_ASSET__c$oD1ayb__"